import { useSearchParams } from "react-router-dom";
import FeatureLocked from "@/components/FeatureLocked";

export default function Upgrade() {
  const [params] = useSearchParams();
  return (
    <div className="mx-auto max-w-xl py-10" data-testid="upgrade-page">
      <FeatureLocked featureKey={params.get("feature")} />
    </div>
  );
}
